var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrolltotop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Scrolltotop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Top",
    className: "st0",
    d: "M20,0c11,0,20,9,20,20s-9,20-20,20S0,31,0,20S9,0,20,0z M20,11.2l-8,8l1.5,1.5l5.3-5.4v13.5h2.2 V15.4l5.4,5.4l1.5-1.5L20,11.2z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "12,19.2 13.5,20.7 18.9,15.4 18.9,28.8 21.1,28.8 21.1,15.4 26.5,20.7 28,19.2 20,11.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrolltotop);
export default __webpack_public_path__ + "static/media/Scrolltotop.c356ce670c35d42c74914d1ce41444c3.svg";
export { ForwardRef as ReactComponent };